module.exports = __webpack_public_path__ + "static/media/md-duran-1551156-unsplash.c529b9a1.jpg";